import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

const PIXEL_ID = '910442638642236'

let isInitialized = false

function initPixel() {
  if (isInitialized || typeof window === 'undefined') return

  // Meta Pixel base code
  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)

  isInitialized = true
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
    // Fire PageView on mount
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Método Noches en Paz',
        content_type: 'product',
        value: 24900,
        currency: 'COP',
      })
    }
  }, [])

  return { trackAddToCart }
}
